import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import CategoriesList from "./features/categories/CategoriesList";
import ProductsList from "./features/products/ProductsList";
import CategoryForm from "./components/CategoryForm";
import ProductForm from "./components/ProductForm";
import { Container } from "react-bootstrap";


import ProtectedRoute from "./ProtectedRoute";
import LoginPage from "./LoginPage";
import Home from "./Home";
import AccPriceManager from "./components/AccPriceManager";
import BlogEditor from "./components/BlogEditor";
import AddWebsite from "./components/AddWebsite";
import EditBlog from "./components/EditBlog";
import BlogList from "./components/BlogList";





function App() {
  return (
    <Router>
      <Navbar />
      <Container className="mt-4">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><Home/></ProtectedRoute>} />
          <Route path="/categories" element={      <ProtectedRoute><CategoriesList /></ProtectedRoute>} />
          <Route path="/products" element={ <ProtectedRoute><ProductsList /></ProtectedRoute>} />
          <Route path="/add-category" element={<ProtectedRoute><CategoryForm /></ProtectedRoute> } />
          <Route path="/add-product" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
          <Route path="/Accessory" element={<ProtectedRoute><AccPriceManager /></ProtectedRoute>} />
          <Route path="/add-blog" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
          <Route path="/add-website" element={<ProtectedRoute><AddWebsite /></ProtectedRoute>} />
          <Route path="/edit-blog" element={<ProtectedRoute><BlogList /></ProtectedRoute>} />

<Route path="/edit-blog/:id" element={<EditBlog />} />


        </Routes>
      </Container>
    </Router>
  );
}

export default App;
